module.exports = __webpack_public_path__ + "img/it.8b3faf97.svg";